import { defineComponent, ref, h } from 'vue';
import DragDropPlugin from '@uppy/drag-drop';
import { Uppy } from '@uppy/core';
import useUppy from "./useUppy.js";
export default defineComponent({
  name: 'DragDrop',
  props: {
    uppy: {
      type: Uppy,
      required: true
    },
    props: {
      type: Object
    }
  },
  setup(props) {
    const containerRef = ref();
    const pluginRef = ref();
    const propsRef = ref(props.props);
    const onMount = () => {
      const {
        uppy
      } = props;
      const options = {
        id: 'DragDrop',
        ...props.props,
        target: containerRef.value
      };
      uppy.use(DragDropPlugin, options);
      pluginRef.value = uppy.getPlugin(options.id);
    };
    useUppy(onMount, pluginRef, props.uppy, propsRef);
    return () => h('div', {
      ref: containerRef
    });
  }
});